/**
 * One-line summary of a piston's attributes, e.g.
 * "Size: Double Slide, Flash Gap: 300 µm". Empty fields are skipped.
 * Single source of truth for the parts table and the piston picker.
 */
export default function getPistonSummary(piston) {
  return [
    piston.size && `Size: ${piston.size}`,
    piston.flashGap && `Flash Gap: ${piston.flashGap}`,
  ].filter(Boolean).join(', ');
}
